/// <reference path="../../global/fn.js" />


;(function ($) {

    $.widget("nsp.downloadList", {
        opts: {
        },

        _create: function () {
            this.wrap = this.element;

            $('a', this.wrap).on("click", (e)=>{
                //e.preventDefault()
                var iframe = $(`<iframe id="my-frame" style="display:none;"></iframe>`).appendTo('body')
                $(iframe).attr('url', e.target.href)

                setTimeout(()=>{
                    $('#my-frame').remove()
                })
            })
            
        }


    });
})(jQuery);